import React, { useEffect } from 'react'
import Img from 'gatsby-image'
import styled from 'styled-components'

import { Body, HeadlineM, Overline } from 'components/Text'
import Colors from 'styles/Colors'
import media from 'styles/media'
import video from 'video/simulate-short_v2.mp4'

import { FluidImage } from 'Types'

type Props = {
  data: {
    siemenshero2: FluidImage
  }
}

const SiemensHero2: React.FC<Props> = ({ data }) => {
  return (
    <Wrapper id="rapid-sense">
      <TextWrapper>
        <Label bullet>Seamless workflow</Label>
        <Title>
          Work in Siemens <br /> Process Simulate <br /> directly
        </Title>
        <Paragraph>
          There’s no longer a need to switch between programming and simulation
          programs. RapidPlan integrates with Process Simulate, and can run
          either on the same PC or in a separate environment.
        </Paragraph>
      </TextWrapper>
      <Lines>////////</Lines>
      <ImageBackground></ImageBackground>
      <RobotImage>
        <Video
          // ref={(ref) => setVideoRef(ref)}
          controls={false}
          muted
          autoPlay
          // onCanPlayThrough={() => handleProgress(5)}
          // onLoadStart={() => handleProgress(1)}
          // onLoadedData={() => handleProgress(3)}
          // onLoadedMetadata={() => handleProgress(2)}
          // onCanPlay={() => handleProgress(4)}
          loop
          preload="auto"
        >
          <source src={video} type="video/mp4" />
        </Video>
        {/* <Img fluid={data.siemenshero2.childImageSharp.fluid} /> */}
      </RobotImage>
    </Wrapper>
  )
}

const Wrapper = styled.section`
  position: relative;
  display: flex;
  justify-content: flex-end;
  height: 48.8vw;
  min-height: 715px;
  ${media.tablet} {
    height: 128.5vw;
    min-height: 1135px;
  }
  ${media.mobile} {
    height: 199.2vw;
    min-height: 840px;
  }
`
const TextWrapper = styled.div`
  width: 64.3vw;
  padding: 14vw 0 0 22.7vw;
  background: ${Colors.softBlack};
  ${media.tablet} {
    width: 100%;
    padding: 81.5vw 0 0 48px;
  }
  ${media.mobile} {
    padding: 102.1vw 0 0 12px;
  }
`
const Label = styled(Overline)`
  color: white;
  margin-bottom: 1vw;
  ::after {
    color: ${Colors.neptune};
  }
  ${media.fullWidth} {
    font-size: 0.8vw;
  }
`
const Title = styled(HeadlineM)`
  color: white;
  font-size: 3.2vw;
  margin-bottom: 1vw;
  ${media.tabletLandscape} {
    font-size: 54px;
  }
  ${media.mobile} {
    font-size: 36px;
    margin-top: 15px;
  }
`
const Paragraph = styled(Body)`
  color: white;
  width: 22.9vw;
  span {
    color: red;
  }
  ${media.fullWidth} {
    font-size: 0.9vw;
  }
  ${media.tabletLandscape} {
    width: 360px;
  }
  ${media.tablet} {
    width: 411px;
  }
  ${media.mobile} {
    max-width: calc(100% - 24px);
    margin-top: 21px;
  }
`
const RobotImage = styled.div`
  position: absolute;
  width: 43.6vw;
  top: 12.6vw;
  left: 96px;
  ${media.tablet} {
    width: calc(100% - 96px);
    left: 48px;
    top: 9.4vw;
  }
  ${media.mobile} {
    width: calc(100% - 24px);
    left: 12px;
    top: 25.6vw;
  }
`
const Video = styled.video`
  position: absolute;
  outline: none;
  border: none;
  margin: 0;
  width: 46.1vw;
  top: -1.1vw;
  left: 0.4vw;
  z-index: 1;
  ${media.tabletLandscape} {
    width: 100%;
  }
`
const ImageBackground = styled.div`
  position: absolute;
  width: 43.57vw;
  height: 33.8vw;
  top: 7.5vw;
  left: 24px;
  background-color: ${Colors.neptune};
  ${media.tablet} {
    display: none;
  }
  ${media.mobile} {
    display: none;
  }
`

const Lines = styled(HeadlineM)`
  color: ${Colors.neptune};
  position: absolute;
  right: 101px;
  top: 6.2vw;
  transform: rotate(-90deg);
  ${media.tabletLandscape} {
    font-size: 36px;
  }
  ${media.tablet} {
    top: 88.7vw;
    left: auto;
    right: 14px;
  }
  ${media.mobile} {
    display: none;
  }
`

export default SiemensHero2
